import { httpRequest } from '@calendly/http-tools'
import { I18n } from '@calendly/i18n'
import { createAsyncThunk } from '@reduxjs/toolkit'

const transformResponse = (data) => data || {}
export const removeDowngradeAction = createAsyncThunk(
  'removeDowngrade/removeDowngradeAction',
  async (_, { rejectWithValue }) => {
    const [success, response] = await httpRequest({
      url: '/api/billing/subscription/remove_downgrades',
      method: 'PATCH',
      transformResponse
    })

    if (!success) {
      return rejectWithValue(I18n.t('errors.server.server'))
    }

    return response
  }
)
